export const DebitType = {
  RECEIVE: 1,
  PAYMENT: 2,
};

export const DebitTypeOptions = [
  {
    value: DebitType.RECEIVE,
    label: 'Đối trừ phải thu từ nhà cung cấp',
  },
  {
    value: DebitType.PAYMENT,
    label: 'Giảm công nợ phải trả nhà cung cấp',
  },
];

export const DiscountBasisCode = {
  PRE_VAT: 'PRE_VAT',
  POST_VAT: 'POST_VAT',
};

export const DiscountBasisOptions = [
  {
    value: DiscountBasisCode.PRE_VAT,
    label: 'Tính trên giá trước VAT',
  },
  {
    value: DiscountBasisCode.POST_VAT,
    label: 'Tính trên giá sau VAT',
  },
];

export const AccountingTreatmentCode = {
  NET_ON_INVOICE: 'NET_ON_INVOICE',
  AP_CREDIT_NOTE: 'AP_CREDIT_NOTE',
  END_PERIOD_REBATE: 'END_PERIOD_REBATE',
  PAYMENT_DISCOUNT: 'PAYMENT_DISCOUNT',
};

export const AccountingTreatmentOptions = [
  {
    value: AccountingTreatmentCode.NET_ON_INVOICE,
    label: 'Chiết khấu thương mại trên hóa đơn',
  },
  {
    value: AccountingTreatmentCode.AP_CREDIT_NOTE,
    label: 'Chiết khấu đạt SL/doanh số mua rồi mới hưởng',
  },
  {
    value: AccountingTreatmentCode.END_PERIOD_REBATE,
    label: 'Hoàn chiết khấu / hỗ trợ sau báo cáo',
  },
  {
    value: AccountingTreatmentCode.PAYMENT_DISCOUNT,
    label: 'Chiết khấu thanh toán',
  },
];

export const ApplyPartnerTypeCode = {
  SUPPLIER: 'SUPPLIER',
  MANUFACTURER: 'MANUFACTURER',
  BOTH: 'BOTH',
};

export const ApplyPartnerTypeOptions = [
  {
    value: ApplyPartnerTypeCode.SUPPLIER,
    label: 'Nhà cung cấp',
  },
  {
    value: ApplyPartnerTypeCode.MANUFACTURER,
    label: 'Hãng / brand tài trợ',
  },
  {
    value: ApplyPartnerTypeCode.BOTH,
    label: 'Hãng và nhà cung cấp',
  },
];

export const ProcurementDiscountTypeCode = {
  DIRECT_PERCENT: 'DIRECT_PERCENT',
  DIRECT_AMOUNT_ORDER: 'DIRECT_AMOUNT_ORDER',
  DIRECT_AMOUNT_PER_UNIT: 'DIRECT_AMOUNT_PER_UNIT',
  TIER_BY_QTY: 'TIER_BY_QTY',
  TIER_BY_ORDER_VALUE: 'TIER_BY_ORDER_VALUE',
  PERIOD_REBATE: 'PERIOD_REBATE',
};

export const ProcurementDiscountTypeOptions = [
  {
    value: ProcurementDiscountTypeCode.DIRECT_PERCENT,
    label: 'Xác định theo %',
  },
  {
    value: ProcurementDiscountTypeCode.DIRECT_AMOUNT_ORDER,
    label: 'Xác định theo tiền / đơn',
  },
  {
    value: ProcurementDiscountTypeCode.DIRECT_AMOUNT_PER_UNIT,
    label: 'Xác định theo tiền / đơn vị',
  },
  {
    value: ProcurementDiscountTypeCode.TIER_BY_QTY,
    label: 'Đạt theo số lượng mua',
  },
  {
    value: ProcurementDiscountTypeCode.TIER_BY_ORDER_VALUE,
    label: 'Đạt theo doanh số / giá trị mua',
  },
  {
    value: ProcurementDiscountTypeCode.PERIOD_REBATE,
    label: 'Theo báo cáo bán ra / cuối kỳ',
  },
];

export const SettlementDocumentCode = {
  INVOICE: 'INVOICE',
  CREDIT_NOTE: 'CREDIT_NOTE',
  REBATE_STATEMENT: 'REBATE_STATEMENT',
  PAYMENT_SETTLEMENT: 'PAYMENT_SETTLEMENT',
};

export const SettlementDocumentOptions = [
  {
    value: SettlementDocumentCode.INVOICE,
    label: 'Hóa đơn mua hàng',
  },
  {
    value: SettlementDocumentCode.CREDIT_NOTE,
    label: 'Chứng từ giảm công nợ / hóa đơn điều chỉnh',
  },
  {
    value: SettlementDocumentCode.REBATE_STATEMENT,
    label: 'Quyết toán hỗ trợ / hoàn chiết khấu cuối kỳ',
  },
  {
    value: SettlementDocumentCode.PAYMENT_SETTLEMENT,
    label: 'Đối trừ khi thanh toán',
  },
];

export const RecognitionTimingCode = {
  ON_INVOICE: 'ON_INVOICE',
  ON_CREDIT_NOTE: 'ON_CREDIT_NOTE',
  PERIOD_END: 'PERIOD_END',
  ON_PAYMENT: 'ON_PAYMENT',
};

export const RecognitionTimingOptions = [
  {
    value: RecognitionTimingCode.ON_INVOICE,
    label: 'Ghi nhận ngay trên hóa đơn',
  },
  {
    value: RecognitionTimingCode.ON_CREDIT_NOTE,
    label: 'Ghi nhận khi nhận chứng từ giảm công nợ',
  },
  {
    value: RecognitionTimingCode.PERIOD_END,
    label: 'Ghi nhận sau báo cáo / cuối kỳ',
  },
  {
    value: RecognitionTimingCode.ON_PAYMENT,
    label: 'Ghi nhận khi thanh toán',
  },
];

export const VatAdjustmentModeCode = {
  REDUCE_INPUT_VAT: 'REDUCE_INPUT_VAT',
  NO_VAT_ADJUSTMENT: 'NO_VAT_ADJUSTMENT',
};

export const VatAdjustmentModeOptions = [
  {
    value: VatAdjustmentModeCode.REDUCE_INPUT_VAT,
    label: 'Có điều chỉnh VAT đầu vào',
  },
  {
    value: VatAdjustmentModeCode.NO_VAT_ADJUSTMENT,
    label: 'Không điều chỉnh VAT đầu vào',
  },
];

export const SettlementPartyCode = {
  SUPPLIER: 'SUPPLIER',
  MANUFACTURER: 'MANUFACTURER',
  BOTH: 'BOTH',
};

export const SettlementPartyOptions = [
  {
    value: SettlementPartyCode.SUPPLIER,
    label: 'Nhà cung cấp quyết toán',
  },
  {
    value: SettlementPartyCode.MANUFACTURER,
    label: 'Hãng / brand quyết toán hỗ trợ',
  },
  {
    value: SettlementPartyCode.BOTH,
    label: 'Hãng và nhà cung cấp cùng quyết toán',
  },
];

export const AffectsInventoryCostOptions = [
  {
    value: 1,
    label: 'Có điều chỉnh giá vốn / giá trị tồn kho',
  },
  {
    value: 0,
    label: 'Không điều chỉnh giá vốn, chỉ ghi nhận hỗ trợ khác',
  },
];

export const CostAllocationMethodCode = {
  ON_HAND_AND_SOLD_SPLIT: 'ON_HAND_AND_SOLD_SPLIT',
  ON_HAND_ONLY: 'ON_HAND_ONLY',
  COGS_ONLY: 'COGS_ONLY',
  NO_COST_ALLOCATION: 'NO_COST_ALLOCATION',
};

export const CostAllocationMethodOptions = [
  {
    value: CostAllocationMethodCode.ON_HAND_AND_SOLD_SPLIT,
    label: 'Phân bổ cho tồn còn lại và 632 phần đã bán',
  },
  {
    value: CostAllocationMethodCode.ON_HAND_ONLY,
    label: 'Chỉ điều chỉnh tồn kho còn lại',
  },
  {
    value: CostAllocationMethodCode.COGS_ONLY,
    label: 'Chỉ ghi giảm 632 / chi phí kỳ',
  },
  {
    value: CostAllocationMethodCode.NO_COST_ALLOCATION,
    label: 'Không điều chỉnh giá vốn',
  },
];

export const TradeInProgramApplyStatus = {
  ALL: 0,
  APPLYING: 1,
  NOT_APPLIED: 2,
  STOPPED: 3,
};

export const TradeInProgramApplyStatusOptions = [
  {
    value: TradeInProgramApplyStatus.ALL,
    label: 'Tất cả',
  },
  {
    value: TradeInProgramApplyStatus.APPLYING,
    label: 'Đang áp dụng',
  },
  {
    value: TradeInProgramApplyStatus.NOT_APPLIED,
    label: 'Chưa áp dụng',
  },
  {
    value: TradeInProgramApplyStatus.STOPPED,
    label: 'Dừng áp dụng',
  },
];

export const CurrencyType = {
  MONEY: 1, // theo đ
  PERCENT: 2, // theo %
};

export const PromotionCodeType = {
  SUPPLIER: 1,
  SHOPDUNK: 0, // legacy only
};

export const PromotionCodeTypeOptions = [
  {
    key: PromotionCodeType.SUPPLIER,
    value: PromotionCodeType.SUPPLIER,
    label: 'Mã chiết khấu / mã báo giá của đối tác',
  },
];

export const ServicePackageType = {
  FREE: 1,
  ADD_TIME: 0,
};

export const ServicePackageTypeOptions = [
  {
    key: ServicePackageType.FREE,
    value: ServicePackageType.FREE,
    label: 'Được miễn phí gói dịch vụ',
  },
  {
    key: ServicePackageType.ADD_TIME,
    value: ServicePackageType.ADD_TIME,
    label: 'Được nhận thêm thời gian sử dụng gói dịch vụ',
  },
];

export const InstallmentType = {
  FINANCE_COMPANY: 1,
  BANK: 0,
};

export const InstallmentTypeOptions = [
  {
    key: InstallmentType.FINANCE_COMPANY,
    value: InstallmentType.FINANCE_COMPANY,
    label: 'Trả góp qua công ty tài chính',
  },
  {
    key: InstallmentType.BANK,
    value: InstallmentType.BANK,
    label: 'Trả góp qua ngân hàng',
  },
];

export const ReviewStatus = {
  PENDING: 2,
  ACCEPT: 1,
  REJECT: 0,
};

export const ReviewStatusOptions = [
  {
    key: ReviewStatus.PENDING,
    value: ReviewStatus.PENDING,
    label: 'Chưa duyệt',
  },
  {
    key: ReviewStatus.ACCEPT,
    value: ReviewStatus.ACCEPT,
    label: 'Đã duyệt',
  },
  {
    key: ReviewStatus.REJECT,
    value: ReviewStatus.REJECT,
    label: 'Từ chối',
  },
];

export const tabs = {
  ALL: 0,
  APPLY_REVIEW: 1,
  REJECT_REVIEW: 2,
  PENDING_REVIEW: 3,
  APPLYING: 4,
  NOT_APPLIED: 5,
  STOPPED: 6,
};

export const tabOptions = [
  {
    value: tabs.ALL,
    label: 'Tất cả',
  },
  {
    value: tabs.APPLY_REVIEW,
    label: 'Đồng ý duyệt',
  },
  {
    value: tabs.REJECT_REVIEW,
    label: 'Từ chối duyệt',
  },
  {
    value: tabs.PENDING_REVIEW,
    label: 'Chưa duyệt',
  },
  {
    value: tabs.APPLYING,
    label: 'Đang áp dụng',
  },
  {
    value: tabs.NOT_APPLIED,
    label: 'Chưa áp dụng',
  },
  {
    value: tabs.STOPPED,
    label: 'Dừng áp dụng',
  },
];
